import {NoteMIDI} from '../helpers/mappings';


import {DegreeStep} from '../helpers/mappings';
import {roots} from '../helpers/mappings';
import {computeNoteClass} from '../helpers/mappings';

export class Guitar {
    constructor() {
        this.numFrets = 16//15 + open string;
        this.matrix = [[]];

        //Step della root attuale: 0 C, 1 C# etc
        this.rootStep = 0;

        //Mapping midi step -> tono (e.g. 10 = b7)
        this.stepToTonesMapping = {
            0: '1', 1: 'b2', 2: '2', 3: 'b3', 4: '3', 5: '4', 6: '#4', 7: '5', 8: 'b6', 9: '6', 10: 'b7', 11: '7'
        }
        //Mapping midi step -> nome nota (e.g. 10 = Bb)
        this.stepToNoteMapping = {
            0: 'C', 1: 'Db', 2: 'D', 3: 'Eb', 4: 'E', 5: 'F', 6: 'F#', 7: 'G', 8: 'Ab', 9: 'A', 10: 'Bb', 11: 'B'
        }

        this.setStandardTuning();
        this.setFretTonesAndClass();

        this.chordMode = true;

        this.layers = [];
    }

    addLayer() {
        this.layers.push({
            matrix: JSON.parse(JSON.stringify(this.matrix)), rootStep: this.rootStep, stepToTonesMapping: this.stepToTonesMapping, stepToNoteMapping: this.stepToNoteMapping

        })
    }


    getNumFrets() {

        if (this.matrix.length > 0) {
            return this.matrix[0].length;
        }
        return 0;
    }

    getNumStrings() {
        return this.matrix.length;
    }

    //Aggiorna mapping midi step -> tono (e.g. 10 = b7)
    setStepToTonesMapping(mapping, layer = null) {

        if (layer === null) {
            this.stepToTonesMapping = mapping;
        } else {
            this.layers[layer].stepToTonesMapping = mapping;
        }

    }

    //Aggiorna mapping midi step -> tono (e.g. 10 = Bb)
    setStepToNoteMapping(mapping, layer = null) {
        if (layer === null) {
            this.stepToNoteMapping = mapping;
        } else {
            this.layers[layer].stepToNoteMapping = mapping;
        }
    }

    setRootStep(rootStep, layer = null) {
        if (layer === null) {
            this.rootStep = rootStep;
            this.setFretTonesAndClass();
        } else {
            this.layers[layer].rootStep = rootStep;
            this.setFretTonesAndClass(layer);
        }

    }

    setStandardTuning() {
        let initFretShow = false;
        this.matrix = [[{'midi': NoteMIDI.E4, 'note': this.stepToNoteMapping[NoteMIDI.E4 % 12], 'show': initFretShow, 'tone': '1', 'isPlay': false}],
            [{'midi': NoteMIDI.B3, 'note': this.stepToNoteMapping[NoteMIDI.B3 % 12], 'show': initFretShow, 'tone': 'b2', 'isPlay': false}],
            [{'midi': NoteMIDI.G3, 'note': this.stepToNoteMapping[NoteMIDI.G3 % 12], 'show': initFretShow, 'tone': '2', 'isPlay': false}],
            [{'midi': NoteMIDI.D3, 'note': this.stepToNoteMapping[NoteMIDI.D3 % 12], 'show': initFretShow, 'tone': 'b3', 'isPlay': false}],
            [{'midi': NoteMIDI.A2, 'note': this.stepToNoteMapping[NoteMIDI.A2 % 12], 'show': initFretShow, 'tone': '3', 'isPlay': false}],
            [{'midi': NoteMIDI.E2, 'note': this.stepToNoteMapping[NoteMIDI.E2 % 12], 'show': initFretShow, 'tone': '4', 'isPlay': false}],]

        let toneCount = 0;
        for (let s = 0; s < this.matrix.length; s++) {
            for (let f = 0; f < this.numFrets - 1; f++) {

                toneCount += 1;
                if (toneCount > 11) {
                    toneCount = 0;
                }
                let item = this.matrix[s][f];
                let newItem = {
                    'midi': item.midi + 1, 'note': this.stepToNoteMapping[(item.midi + 1) % 12], 'show': initFretShow, 'tone': this.stepToTonesMapping[toneCount], 'isPlay': false
                }
                this.matrix[s].push(newItem);
            }
        }
    }

    toggleFret(string, fret, layer = null) {
        if (layer === null) {
            this.matrix[string][fret].show = !this.matrix[string][fret].show;
        }

    }

    setFretTonesAndClass(layer = null) {

        let matrix = this.matrix;
        let stepToTonesMapping = this.stepToTonesMapping;
        let rootStep = this.rootStep;

        if (layer !== null) {
            matrix = this.layers[layer].matrix;
            stepToTonesMapping = this.layers[layer].stepToTonesMapping;
            rootStep = this.layers[layer].rootStep
        }

        matrix.forEach(row => {
            row.forEach(fret => {
                let step = (fret.midi % 12) - rootStep;
                if (step < 0) {
                    step = step + 12;
                }
                fret.tone = stepToTonesMapping[step];

                //setta la classe della nota in base alla tonalita' impostata
                fret.noteClass = computeNoteClass(fret.midi % 12, this.rootStep);

            })
        });
    }

    showFrets(frets, layer = null) {

        let matrix = this.matrix;
        if (layer !== null) {
            matrix = this.layers[layer].matrix;
        }

        frets.forEach(item => {
            // se è nota singola
            if (typeof item[0] === 'number') {
                let string = item[0] - 1; // in guitar.js le corde sono in base 0-5
                let fret = item[1]
                matrix[string][fret].show = true;
            }

            // se e' array:
            if (Array.isArray(item[0]) === true) {
                item.forEach(el => {
                    let string = el[0] - 1; // in guitar.js le corde sono in base 0-5
                    let fret = el[1]
                    matrix[string][fret].show = true;

                })
            }
        })
    }

    setFretPlay(string, fret, layer = null) {
        let matrix = this.matrix;
        if (layer !== null) {
            matrix = this.layers[layer].matrix;
        }


        // se in chord mode, visualizza tasto
        if (this.chordMode === true) {
            matrix[string][fret].show = true;


        } else {
            //altrimenti tasto e' già visualizzato, lo colora di bianco
            matrix[string][fret].isPlay = true;


        }

    }

    hideAllFrets(layer = null) {
        let matrix = this.matrix;
        if (layer !== null) {
            matrix = this.layers[layer].matrix;
        }

        matrix.forEach(row => {
            row.forEach(fret => {
                fret.show = false;
            })
        });

    }

    setTonesAndNotes(tonesAndNotes, layer = null) {
        let matrix = this.matrix;
        if (layer !== null) {
            matrix = this.layers[layer].matrix;
        }

        matrix.forEach(row => {
            row.forEach(fret => {
                let fretStep = (fret.midi % 12);
                tonesAndNotes.forEach((item, idx) => {
                    let noteName = item[0];
                    let noteTone = item[1]
                    if (idx === fretStep) {
                        fret.tone = noteTone;
                        fret.note = noteName;
                    }
                })
            })
        })

    }

    setTonesAndNotesFromStep(stepsNotesTonesMapping, layer = null) {
        let matrix = this.matrix;
        if (layer !== null) {
            matrix = this.layers[layer].matrix;
        }

        matrix.forEach(row => {
            row.forEach(fret => {
                let fretStep = (fret.midi % 12);

                if (stepsNotesTonesMapping.hasOwnProperty(fretStep)) {
                    fret.tone = stepsNotesTonesMapping[fretStep].tone;
                    fret.note = stepsNotesTonesMapping[fretStep].note;
                }

            })
        })

    }

    showSelectedTones(state, tones, layer = null) {

        let matrix = this.matrix;
        let rootStep = this.rootStep;

        if (layer !== null) {
            matrix = this.layers[layer].matrix;
            rootStep = this.layers[layer].rootStep;
        }

        matrix.forEach(row => {
            row.forEach(fret => {
                let fretStep = (fret.midi % 12) - rootStep;
                if (fretStep < 0) {
                    fretStep = fretStep + 12;
                }
                tones.forEach(tone => {
                    let toneStep = DegreeStep[tone]
                    if (toneStep === fretStep) {
                        fret.tone = tone;
                        fret.show = true;
                    }
                })
            })
        });

    }

    resetFretsPlay(state, layer = null) {
        let matrix = this.matrix;
        if (layer !== null) {
            matrix = this.layers[layer].matrix;
        }

        matrix.forEach(row => {
            row.forEach(fret => {
                fret.isPlay = false;

                if (this.chordMode === true) {
                    fret.show = false;
                }

            })
        });

    }
}
